/** Compatibility entrypoint (BKPE-27796). */
export * from 'features/analytics/constants';
